<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="学业影响力排行"
      :expand-all-row="true"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      :show-reset="false"
      table-title="信息列表"
      :custom-search="customSearch"
      @count="count"
      null-tip="当前考试暂无数据"
      @search="search"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="入学年份" :style="isMB?'':'margin-left:18px;'">
          <el-select v-model="data.SchoolYear" size="mini" style="width:100%;" @change="reset" disabled placeholder="">
            <el-option v-for="item in yearList" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前考试名称" class="listLabel">
          <el-input v-model="data.ThisLvSn" size="mini" readonly placeholder=""/>
        </el-form-item>
        <!-- <el-form-item label="入口考试名称" class="listLabel">
          <el-input v-model="data.EntryLvSn" size="mini" readonly class="entryInp" placeholder=""/>
        </el-form-item> -->
        <div class="entryBox">
          <span class="entryTitle">入口考试名称</span>
          <el-input class="entrySelect" v-model="data.EntryLvSn" size="mini" :title="data.EntryLvSn" readonly placeholder=""/>
        </div> 
      </template>
      <template slot="table">
        <slot name="column">
          <el-table-column prop="ClassName" label="班级"/>
          <el-table-column prop="SubjectName" label="科目"/>
          <el-table-column prop="TeacherName" label="姓名">
            <template slot-scope="{row}">
              <el-link style="font-size:12px;" @click="toDetails(row)">{{row.TeacherName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="IndexLv" label="本次等级"/>
          <el-table-column prop="ThisPeriodRate" label="本期相对推进率（%）"/>
          <el-table-column prop="IndexScore" label="本期累计评分"/>
        </slot>
      </template>
    </list>
    <exam-dialog ref="examDialog" in-dialog selectable :multiple="false" @select="setThis"></exam-dialog>
    <exam-dialog2 ref="examDialog2" in-dialog selectable :multiple="true" @select-multiple="setEntry"></exam-dialog2>
    <entry-dialog ref="entryDialog" @confirm="confirm"></entry-dialog>
    <search-dialog ref="searchDialog" @confirm="confirm2"></search-dialog>
    <details-dialog ref="detailsDialog" in-dialog></details-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import examDialog from "@/components/achieve/exam/listDialog";
import examDialog2 from "@/components/achieve/exam/listDialog";
import entryDialog from "./entryDialog";
import searchDialog from "./searchDialog";
import detailsDialog from "./detailsDialog";

export default {
  mixins: [listMixin],
  components: { 
    list,
    examDialog,
    examDialog2,
    entryDialog,
    searchDialog,
    detailsDialog
  },
  data() {
    return {
      api: require("@/api/analyse/analyse").default,
      examApi: require("@/api/achieve/exam").default,
      AnalyseId: null,
      params: {
        Entries: [],
        ThisExamId: null,
        AnalyseType: 3
      },
      data: {
        ThisLvSn: null,
        SchoolYear: "",
        EntryLvSn: "",
      },
      EntryLvSn: "",
      Entries: [],
      yearList: [],
      TermId: null,
      tbl: [],
      searchParams: {},
      customSearch: [
        // { bn: "统计", fn: 'count' },
        { bn: "查询", fn: 'search' },
      ]
    };
  },
  beforeMount() {
    this.examApi.getYear().then(res => {
      for (let i = res.Data.length-1; i > -1; i--) {
        this.yearList.push(res.Data[i])
      }
    })
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.getTeacherRank(this.searchParams).then(res => {
          resolve({ Data: res.Data });
        });
      });
    },
    onExamDialog(type) {
      if(!this.data.SchoolYear) {
        this.$message.error("请先选择入学年份")
        return
      }
      if(type) {
        this.$refs.examDialog2.open().then((that) => {
          that.getData({ SchoolYear: this.data.SchoolYear, ExamType: 0 });
        });
      } else {
        this.$refs.examDialog.open().then((that) => {
          that.getData({ SchoolYear: this.data.SchoolYear, ExamType: 0 });
        });
      }
    },
    setThis(exam) {
      this.TermId = exam.TermId;
      this.params.ThisExamId = exam.ExamId;
      this.data.ThisLvSn = exam.ExamCode;
    },
    setEntry(exam) {
      this.Entries = [];
      this.EntryLvSn = "";
      if(exam.length==0) {
        return
      }
      exam.forEach((e,index) => {
        this.Entries.push({
          EntryExamId: e.ExamId,
          EntryRatio: 0,
        })
        this.EntryLvSn += e.ExamCode;
        if(exam[index+1]) {
          this.EntryLvSn += '，';
        }
      });
      this.openDialog(exam.length)
    },
    openDialog(num) {
      this.$refs.entryDialog.open();
      this.$refs.entryDialog.setData(num);
    },
    count() {
      if(!this.data.ThisLvSn) {
        this.$message.error("请先选择考试")
        return
      }
      if(this.Entries.length==0) {
        this.$message.error("请先选择入口考试")
        return
      }
      this.query();
    },
    confirm(data) {
      this.Entries.forEach((e,index) => {
        e.EntryRatio = Number(data[index].ExamRatio)
      })
      this.data.EntryLvSn = this.EntryLvSn;
      this.params.Entries = this.Entries;
    },
    confirm2(data) {
      let obj = { Id: this.AnalyseId, ClassIds: data.ClassIds };
      if(data.type === 0) {
        obj.RecentTop5 = true;
      } else if(data.type === 1) {
        obj.Bad30 = true;
      } else if(data.type === 3) {
        obj.Good30 = true;
      }
      this.searchParams = obj;
      this.query();
    },
    setData(data) {
      if(!data.AnalyseId) {
        this.$message.warning("请先在综合评价指标生成统计数据");
       return 
      }
      if(data.AnalyseId !== this.AnalyseId) {
        this.AnalyseId = data.AnalyseId;
        this.searchParams.Id = data.AnalyseId;
        this.params = data.params;
        this.data = data.data;
        this.EntryLvSn = data.EntryLvSn;
        this.Entries = data.Entries;
        this.TermId = data.TermId;
        this.query();
      } else {
        this.AnalyseId = data.AnalyseId;
        this.searchParams.Id = data.AnalyseId;
        this.params = data.params;
        this.data = data.data;
        this.EntryLvSn = data.EntryLvSn;
        this.Entries = data.Entries;
        this.TermId = data.TermId;
      }
    },
    search() {
      // if(!this.params.ThisExamId) {
      //   this.$message.error("请先选择当前考试");
      //   return
      // }
      // if(this.params.Entries.length==0) {
      //   this.$message.error("请先选择入口考试");
      //   return
      // }
      if(!this.AnalyseId) {
        this.$message.warning("请先在综合评价指标生成统计数据");
        return;
      }
      this.$refs.searchDialog.open();
      this.$refs.searchDialog.setData(this.params.ThisExamId,this.TermId);
    },
    toDetails(row) {
      let name = "";
      switch (row.SubjectName) {
        case "语文":
          name = "ThisYwTeacherId"
          break;
        case "数学":
          name = "ThisSxTeacherId"
          break;
        case "英语":
          name = "ThisYyTeacherId"
          break;
        case "物理":
          name = "ThisWlTeacherId"
          break;
        case "化学":
          name = "ThisHxTeacherId"
          break;
        case "生物":
          name = "ThisSwTeacherId"
          break;
        case "历史":
          name = "ThisLsTeacherId"
          break;
        case "政治":
          name = "ThisZzTeacherId"
          break;
        case "地理":
          name = "ThisDlTeacherId"
          break;
      }
      row.AnalyseId = this.AnalyseId;
      this.$refs.detailsDialog.open({ ...row, name, teachername: "TeacherName" });
    },
    reset() {
      this.AnalyseId = null;
      this.params.Entries = [];
      this.params.ThisExamId = null;
      this.data.ThisLvSn = "";
      this.data.EntryLvSn = "";
      this.TermId = null;
    },
    export() {
      if(!this.AnalyseId) {
        this.$message.warning("请先在综合评价指标生成统计数据");
        return;
      }
      this.api.exportTeacherRank(this.searchParams)
    },
  },
};
</script>
<style lang="scss" secopd>
.el-link {
  vertical-align: top;
}
</style>